import { useTranslation } from 'react-i18next'

export const Footer = () => {
	const { t } = useTranslation()

	const handleScroll = (id: string) => {
		const section = document.getElementById(id)
		if (section) {
			section.scrollIntoView({ behavior: 'smooth' })
		}
	}
	return (
		<footer id="contact" className="relative bg-white">
			<div className="flex md:flex-row flex-col justify-between md:gap-24 gap-10 sm:py-12 py-8 bg-fixed xl:px-20 lg:px-10 md:px-14 px-4">
				<div>
					<img
						className="h-12"
						src={require('@/assets/images/arirang.png')}
						alt="arirang"
					/>
					<div className="text-base text-neutral-600 xl:whitespace-pre-line mt-3">
						{t('footer_info')}
					</div>
				</div>
				<div className="flex md:gap-24 gap-10">
					<nav className="flex flex-col md:gap-4 gap-2">
						<div className="font-bold md:text-lg text-base text-black">
							{t('menu')}
						</div>
						<span
							className="font-normal md:text-base text-sm text-black cursor-pointer"
							onClick={() => handleScroll('home')}
						>
							{t('home')}
						</span>
						<span
							className="font-normal md:text-base text-sm text-black cursor-pointer"
							onClick={() => handleScroll('program')}
						>
							{t('program')}
						</span>
						<span
							className="font-normal md:text-base text-sm text-black cursor-pointer"
							onClick={() => handleScroll('product')}
						>
							{t('product')}
						</span>
						<span
							className="font-normal md:text-base text-sm text-black cursor-pointer"
							onClick={() => handleScroll('contact')}
						>
							{t('contact_us')}
						</span>
					</nav>
					<div className="flex flex-col md:gap-4 gap-2 max-w-60">
						<div className="font-bold md:text-lg text-base text-black">
							{t('contact')}
						</div>
						<a
							href="https://maps.app.goo.gl/GVs4xJwenb1FDRaQ6"
							target="_blank"
							rel="noreferrer"
							className="font-normal md:text-base text-sm text-black"
						>
							Jl. Bintaro Raya No.15, Kby. Lama Sel., Kec. Kebayoran Lama, Kota
							Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12240
						</a>
						<div>
							<div className="flex md:gap-4 gap-1">
								<img
									className="h-6 w-6 shrink-0"
									src={require('@/assets/icons/email.png')}
									alt="arirang"
								/>
								<a
									href="mailto:info@jakaranatama.co.id"
									className="font-normal md:text-base text-sm text-black"
								>
									info@jakaranatama.co.id
								</a>
							</div>
							<div className="flex md:gap-4 gap-1 mt-2">
								<img
									className="h-6 w-6 shrink-0"
									src={require('@/assets/icons/phone.png')}
									alt="arirang"
								/>
								<a
									href="tel:+628001403202"
									className="font-normal md:text-base text-sm text-black"
								>
									+62 800 1403 202
								</a>
							</div>
						</div>
					</div>
				</div>
				<nav className="flex flex-col md:gap-4 gap-2 max-w-60">
					<div className="font-bold text-lg text-black">{t('follow_us')}</div>
					<div className="flex items-center gap-3">
						<a
							href="https://facebook.com/arirang.taste"
							className="w-9 h-9 rounded-full border border-[#0D062D29] flex items-center justify-center text-indigo-900 hover:scale-110 hover:text-white transition"
							target="_blank"
							rel="noreferrer"
						>
							<img
								className="h-5 object-contain"
								src={require('@/assets/icons/facebook.png')}
								alt="facebook"
							/>
						</a>
						<a
							href="https://www.youtube.com/channel/UCULijpXxRqM-JuwLHOpQ8yw"
							className="w-9 h-9 rounded-full border border-[#0D062D29] flex items-center justify-center text-indigo-900 hover:scale-110 hover:text-white transition"
							target="_blank"
							rel="noreferrer"
						>
							<img
								className="h-5 object-contain"
								src={require('@/assets/icons/youtube.png')}
								alt="youtube"
							/>
						</a>
						<a
							href="http://instagram.com/arirang.taste"
							className="w-9 h-9 rounded-full border border-[#0D062D29] flex items-center justify-center text-indigo-900 hover:scale-110 hover:text-white transition"
							target="_blank"
							rel="noreferrer"
						>
							<img
								className="h-5 object-contain"
								src={require('@/assets/icons/instagram.png')}
								alt="instagram"
							/>
						</a>
						<a
							href="https://www.tiktok.com/@arirang.taste"
							className="w-9 h-9 rounded-full border border-[#0D062D29] flex items-center justify-center text-indigo-900 hover:scale-110 hover:text-white transition"
							target="_blank"
							rel="noreferrer"
						>
							<img
								className="h-5 object-contain"
								src={require('@/assets/icons/tiktok.png')}
								alt="tiktok"
							/>
						</a>
					</div>
				</nav>
			</div>
			<div className="font-noral text-base text-center p-5 text-neutral-600 border-t border-gray-100">
				©2025 Loyal.id All right reserved.
			</div>
		</footer>
	)
}
